import React from "react";
import styles from "./ModuleCard.module.scss";
import { LockIcon } from "../../../../assets/icons";

interface ModuleCardProps {
	title: string;
	description: string;
	image: string;
	type: "bills" | "service-request" | "customer-support" | "client-management" | string;
	link: string;
	showLockIcon?: boolean;
	locked?: boolean;
}

const ModuleCard = ({ title, description, image, type, link, showLockIcon = false, locked = false }: ModuleCardProps) => {
	const getCardClass = () => {
		const baseClass = styles.card;
		const lockedClass = locked ? styles.locked : '';
		if (type === "bills") return `${baseClass} ${styles.billsCard} ${lockedClass}`;
		if (type === "service-request") return `${baseClass} ${styles.serviceRequestCard} ${lockedClass}`;
		if (type === "customer-support") return `${baseClass} ${styles.customerSupportCard} ${lockedClass}`;
		return `${baseClass} ${styles.clientManagementCard} ${lockedClass}`;
	};

	const handleClick = (e: React.MouseEvent) => {
		if (locked) {
			e.preventDefault();
		}
	};

	return (
		<a href={link} className={getCardClass()} onClick={handleClick}>
			{/* Image section */}
			<div className={styles.imageSection} style={{ backgroundImage: `url(${image})` }}>
				{(showLockIcon || locked) && (
					<div className={styles.lockIcon}>
						<LockIcon />
					</div>
				)}
			</div>

			{/* Content section with title, description, and button */}
			<div className={styles.content}>
				<h3 className={styles.title}>{title}</h3>
				<p className={styles.description}>{description}</p>
				<div className={styles.footer}>
					<button className={styles.viewButton}>{locked ? 'Coming Soon' : 'View'}</button>
				</div>
			</div>
		</a>
	);
};

export default ModuleCard;
